<template>
  <ResearchGalleryPage
    page-title="行政管理工作"
    section-label="科研保障"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuXingzhengguanligongzuo',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: '/lanhu_keyanbaozhang',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '年度工作会议',
          kicker: '2012-2017',
          layout: 'hero-pair',
          items: [
            {
              src: require('./assets/html/admin-2012-meeting.jpg'),
              caption: '2012 年 3 月，新闻与传播研究所 2012 年度工作会议在北京昌平召开',
              wide: true
            },
            {
              src: require('./assets/html/admin-2014-meeting.jpg'),
              caption: '2014 年 3 月，新闻与传播研究所 2014 年度工作会议在北京香山召开'
            },
            {
              src: require('./assets/html/admin-2017-meeting.jpg'),
              caption: '2017 年 3 月，新闻与传播研究所 2017 年度工作会议在北京密云召开。图为预备会上在院部听取中央纪委驻中国社会科学院院纪检监察组副组长胡乐生关于党风廉政建设的辅导报告，党委书记、副所长赵天晓主持了讲座'
            }
          ]
        },
        {
          title: '人才招聘与博士后评审',
          kicker: '2016-2018',
          layout: 'hero-pair',
          items: [
            {
              src: require('./assets/html/admin-2016-recruit.jpg'),
              caption: '2016 年 3 月，新闻与传播研究所人事处组织人才引进招聘面试考核',
              wide: true
            },
            {
              src: require('./assets/html/admin-2017-postdoc.jpg'),
              caption: '2017 年 6 月，新闻与传播研究所博士后流动站办公室组织博士后出站评审会'
            },
            {
              src: require('./assets/html/admin-2018-postdoc.jpg'),
              caption: '2018 年 10 月，新闻与传播研究所博士后流动站办公室组织召开博士后出站评审会'
            }
          ]
        }
      ]
    };
  }
};
</script>
